/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Sprite, SpriteProps, CanBeSignals, getProp, destructProp, copyPointData} from '@gongxigames/framework/core/fragments/BuilderY';
import {Override} from '@gongxigames/framework/lib/types/basic';
import {cacheAsSprite} from '@gongxigames/framework/core/fragments/display/CacheAsSprite';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {Point} from 'pixi.js';

export type GetSpriteProps = Override<SpriteProps, CanBeSignals<{
    name: string;
}>>;

export const $GetSprite: FC<GetSpriteProps> = (props) => {
    const textureData = Store.computed(() => {
        const sprite = getProp(props.name);

        return cacheAsSprite.getTexture(sprite);
    });

    const position = Store.computed(() => {
        const position = getProp(props.position) || 0;
        const offset = textureData.value.offset;
        const result = new Point();

        copyPointData(position, result);
        result.x += offset.x;
        result.y += offset.y;

        return result;
    });

    const {texture} = destructProp(textureData, ['offset', 'texture']);

    return <$Sprite {...props} texture={texture} position={position}/>;
};